import { TextoComLinksComponent } from '../shared/texto-com-links/texto-com-links.component';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { WhatsAppGrupo, GrupoMensagem, GrupoMencao, WhatsAppGruposService } from '../../core/services/whatsapp-oficial/whatsapp-grupos.service';

@Component({ selector: 'app-whatsapp-grupos', standalone: true, imports: [CommonModule, FormsModule, TextoComLinksComponent],
  templateUrl: './whatsapp-grupos.component.html', styleUrls: ['./whatsapp-grupos.component.css'] })
export class WhatsAppGruposComponent implements OnInit, OnChanges, OnDestroy {
  @Input() ativa = false;
  @Input() toolbar: TemplateRef<any>;
  @Output() naoLidos = new EventEmitter<number>();
  @ViewChild('historico') historico: ElementRef<HTMLElement>;
  @ViewChild('editor') editor: ElementRef<HTMLTextAreaElement>;
  mencoes: GrupoMencao[] = []; sugestoes: any[] = []; indiceMencao = 0;
  private inicioMencao = -1; private fimMencao = 0;
  grupos: WhatsAppGrupo[] = []; selecionado: WhatsAppGrupo = null; mensagens: GrupoMensagem[] = [];
  membros: any[] = []; membrosAbertos = false; filtro = ''; soNaoLidos = false; texto = '';
  arquivo: File = null; ocupado = false; enviando = false; erro = ''; sincronizado = false;
  carregandoMensagens = false; maisLocal = false; maisRemoto = false; offset = 0;
  private timer: any; private destroyed = false; private consultando = false; private consultaMensagens = false;
  private geracao = 0; private ultimoLido = 0; private chaveEnvio: string = null;
  constructor(private api: WhatsAppGruposService) { }
  ngOnInit() { this.atualizar(); this.timer = setInterval(() => this.tick(), 15000); }
  ngOnChanges() { if (this.ativa && !this.sincronizado) this.sincronizar(); }
  ngOnDestroy() { this.destroyed = true; this.geracao++; clearInterval(this.timer); }
  get filtrados() { const busca = this.filtro.toLocaleLowerCase(); return this.grupos.filter(g => (!this.soNaoLidos || g.mensagens_nao_lidas > 0) && g.nome.toLocaleLowerCase().includes(busca)); }
  get totalNaoLidos() { return this.grupos.filter(g => g.mensagens_nao_lidas > 0).length; }
  get mensagensVisiveis() { return this.mensagens.filter(m=>m.message_type !== 'duplicate'); }
  iniciais(nome: string) { return (nome || '?').split(/\s+/).slice(0,2).map(p => p[0]).join('').toUpperCase(); }
  private falha(error: any) { this.erro = String(error?.error?.message || 'Não foi possível atualizar os grupos.').replace(/uazapi/gi, 'API do Whats'); }
  async atualizar() {
    if (this.consultando || this.destroyed || !localStorage.getItem('whatsapp_grupos_token')) return;
    this.consultando = true;
    try {
      const rows = await firstValueFrom(this.api.listar()); if (this.destroyed) return;
      this.grupos = rows || []; this.naoLidos.emit(this.totalNaoLidos);
      if (this.selecionado) { const current = this.grupos.find(g => g.id === this.selecionado.id); if (current) this.selecionado = current; }
    } catch (error) { if (this.ativa) this.falha(error); }
    finally { this.consultando = false; }
  }
  async sincronizar() {
    if (this.ocupado || this.destroyed) return;
    if (!localStorage.getItem('whatsapp_grupos_token')) { this.erro = 'Entre novamente no portal para acessar os grupos da sua instância.'; return; }
    this.ocupado = true; this.erro = '';
    try { await firstValueFrom(this.api.sincronizar()); this.sincronizado = true; await this.atualizar(); }
    catch (error) { this.falha(error); } finally { this.ocupado = false; }
  }
  async selecionar(grupo: WhatsAppGrupo) {
    if (this.enviando) return;
    const request = ++this.geracao; this.selecionado = grupo; this.mensagens = []; this.membros = [];
    this.membrosAbertos = false; this.texto = ''; this.arquivo = null; this.chaveEnvio = null;
    this.mencoes = []; this.sugestoes = [];
    this.ultimoLido = 0; this.erro = ''; this.carregandoMensagens = true; this.offset = 0;
    try {
      const members = await firstValueFrom(this.api.participantes(grupo.id));
      if (this.geracao !== request || this.destroyed) return;
      this.membros = members;
      const history = await firstValueFrom(this.api.historico(grupo.id, 0, true));
      if (this.geracao !== request || this.destroyed) return;
      this.offset = history.proximo_offset; this.maisRemoto = history.tem_mais;
      const rows = await firstValueFrom(this.api.mensagens(grupo.id));
      if (this.geracao !== request || this.destroyed) return;
      this.mensagens = rows; this.maisLocal = rows.length === 15; await this.atualizar(); this.irAoFim();
    } catch (error) { if (this.geracao === request) this.falha(error); }
    finally { if (this.geracao === request) this.carregandoMensagens = false; }
  }
  private async tick() { await this.atualizar(); if (this.ativa && document.visibilityState === 'visible') await this.recarregar(); }
  async recarregar() {
    if (!this.selecionado || this.consultaMensagens || this.carregandoMensagens || this.destroyed) return;
    const id = this.selecionado.id; const generation = this.geracao; const fim = this.noFim(); this.consultaMensagens = true;
    try {
      const rows = await firstValueFrom(this.api.mensagens(id)); if (generation !== this.geracao || this.destroyed) return;
      this.mesclar(rows); if (fim) this.irAoFim();
    } catch (error) { this.falha(error); } finally { this.consultaMensagens = false; }
  }
  private mesclar(rows: GrupoMensagem[]) { const map = new Map(this.mensagens.map(m => [m.id, m])); rows.forEach(m => map.set(m.id,m)); this.mensagens = Array.from(map.values()).sort((a,b) => Date.parse(a.dt_mensagem)-Date.parse(b.dt_mensagem) || a.id-b.id); }
  async mais() {
    if (!this.selecionado || this.carregandoMensagens) return;
    const id = this.selecionado.id; const generation = this.geracao; this.carregandoMensagens = true;
    try {
      const before = this.mensagensVisiveis[0]?.id;
      let rows = await firstValueFrom(this.api.mensagens(id,before));
      if (generation !== this.geracao || this.destroyed) return;
      for (let page = 0; rows.length < 15 && this.maisRemoto && page < 100; page++) {
        const previousOffset = this.offset;
        const history = await firstValueFrom(this.api.historico(id,this.offset));
        if (generation !== this.geracao || this.destroyed) return;
        this.offset = history.proximo_offset; this.maisRemoto = history.tem_mais;
        rows = await firstValueFrom(this.api.mensagens(id,before));
        if (generation !== this.geracao || this.destroyed) return;
        if (this.offset <= previousOffset) { this.maisRemoto = false; break; }
      }
      this.mesclar(rows); this.maisLocal = rows.length === 15;
    } catch (error) { this.falha(error); } finally { if (generation === this.geracao) this.carregandoMensagens = false; }
  }
  private noFim() { const el = this.historico?.nativeElement; return !el || el.scrollHeight - el.scrollTop - el.clientHeight < 100; }
  private irAoFim() { const generation = this.geracao; setTimeout(() => { if (this.destroyed || generation !== this.geracao) return; const el = this.historico?.nativeElement; if (el) el.scrollTop = el.scrollHeight; this.marcarLido(); }); }
  async marcarLido() {
    if (!this.ativa || document.visibilityState !== 'visible' || !this.noFim() || !this.selecionado || !this.mensagens.length) return;
    const id = this.selecionado.id; const generation = this.geracao; const last = Math.max(...this.mensagens.map(m => m.id));
    if (last <= this.ultimoLido) return;
    this.ultimoLido = last;
    try { await firstValueFrom(this.api.leitura(id,last)); await this.atualizar(); }
    catch (error) { if (generation === this.geracao) { this.ultimoLido = 0; this.falha(error); } }
  }
  selecionarArquivo(event: Event) {
    const input = event.target as HTMLInputElement; const file = input.files?.[0]; input.value = '';
    if (!file) return; if (file.size > 25*1024*1024) { this.erro = 'Selecione um arquivo de até 25 MB.'; return; }
    this.arquivo = file; this.chaveEnvio = null;
  }
  nomeMembro(p: any) { return p.nome || p.telefone || p.participante_jid; }
  editarTexto(event: Event) {
    const el = event.target as HTMLTextAreaElement; const next = el.value; const old = this.texto;
    let inicio = 0; while (inicio < old.length && inicio < next.length && old[inicio] === next[inicio]) inicio++;
    let fimOld = old.length, fimNext = next.length;
    while (fimOld > inicio && fimNext > inicio && old[fimOld-1] === next[fimNext-1]) { fimOld--; fimNext--; }
    const delta = next.length - old.length;
    this.mencoes = this.mencoes.filter(m => m.inicio + m.tamanho <= inicio || m.inicio >= fimOld)
      .map(m => ({...m, inicio: m.inicio >= fimOld ? m.inicio + delta : m.inicio}));
    this.texto = next; this.buscarMencoes(el);
  }
  buscarMencoes(el: HTMLTextAreaElement) {
    const caret = el.selectionStart;
    const match = this.texto.slice(0,caret).match(/(?:^|\s)@([^\s@]*)$/);
    this.sugestoes = [];
    if (!match || el.selectionEnd !== caret) return;
    this.inicioMencao = caret - match[1].length - 1; this.fimMencao = caret;
    if (this.mencoes.some(m => this.inicioMencao >= m.inicio && this.inicioMencao < m.inicio + m.tamanho)) return;
    const normalizar = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase();
    const busca = normalizar(match[1]);
    this.sugestoes = this.membros.filter(p => normalizar(this.nomeMembro(p)).includes(busca)).slice(0,10);
    this.indiceMencao = 0;
  }
  escolherMencao(p: any) {
    const el = this.editor.nativeElement; const inicio = this.inicioMencao;
    const label = '@' + this.nomeMembro(p); const value = this.texto.slice(0,inicio) + label + ' ' + this.texto.slice(this.fimMencao);
    el.value = value; this.editarTexto({target:el} as unknown as Event);
    this.mencoes.push({participante_jid:p.participante_jid,inicio,tamanho:label.length}); this.sugestoes = [];
    el.focus(); el.setSelectionRange(inicio + label.length + 1,inicio + label.length + 1);
  }
  teclaMencao(event: KeyboardEvent) {
    if (!this.sugestoes.length) return;
    if (event.key === 'Escape') { this.sugestoes = []; event.preventDefault(); }
    else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); this.indiceMencao = (this.indiceMencao + (event.key === 'ArrowDown' ? 1 : -1) + this.sugestoes.length) % this.sugestoes.length;
    } else if (event.key === 'Enter' || event.key === 'Tab') { event.preventDefault(); this.escolherMencao(this.sugestoes[this.indiceMencao]); }
  }
  async enviar() {
    if (!this.selecionado?.pode_enviar || this.enviando || (!this.texto.trim() && !this.arquivo)) return;
    const id = this.selecionado.id; this.enviando = true; this.erro = '';
    this.chaveEnvio ||= crypto.randomUUID();
    try {
      const sent = await firstValueFrom(this.arquivo ? this.api.arquivo(id,this.arquivo,this.texto,this.chaveEnvio,this.mencoes) : this.api.enviar(id,this.texto,this.chaveEnvio,this.mencoes));
      this.mesclar([sent]); this.texto = ''; this.arquivo = null; this.chaveEnvio = null; this.irAoFim(); await this.atualizar();
      this.mencoes = []; this.sugestoes = [];
    } catch (error) { this.falha(error); await this.recarregar(); }
    finally { this.enviando = false; }
  }
  async baixar(m: GrupoMensagem) {
    try {
      const blob = await firstValueFrom(this.api.anexo(m.id)); const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a'); anchor.href = url; anchor.download = m.anexos[0]?.nome_arquivo || 'anexo'; anchor.click(); setTimeout(() => URL.revokeObjectURL(url),1000);
    } catch (error) { this.falha(error); }
  }
  trackMensagem(_: number,m: GrupoMensagem) { return m.id; }
}
